import React, { useState, useEffect, useRef } from "react";
import { FaChevronDown } from "react-icons/fa";

// A styled, scrollable dropdown (native <select> replacement). The menu is
// height-capped and scrolls, auto-scrolls to the selected option on open, and
// closes on outside click. Pass `up` to open the menu above the button.
// `align` controls option text alignment: "center" suits short values (HH/MM),
// "left" reads like a normal dropdown for word labels (e.g. shift names).
const ScrollSelect = ({ value, options, onChange, placeholder, minWidth = 68, up = false, align = "center" }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const menuRef = useRef(null);

    useEffect(() => {
        if (!open) return;
        const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        document.addEventListener("mousedown", onDoc);
        return () => document.removeEventListener("mousedown", onDoc);
    }, [open]);

    useEffect(() => {
        if (open && menuRef.current) {
            const active = menuRef.current.querySelector(".shift-ss-opt.active");
            if (active) active.scrollIntoView({ block: "nearest" });
        }
    }, [open]);

    const selected = options.find((o) => String(o.value) === String(value));
    return (
        <div className={`shift-ss shift-ss-${align}`} ref={ref} style={{ minWidth }}>
            <button type="button" className="shift-ss-btn" onClick={() => setOpen((o) => !o)}>
                <span className={selected ? "" : "shift-ss-ph"}>{selected ? selected.label : placeholder}</span>
                <FaChevronDown className="shift-ss-caret" />
            </button>
            {open && (
                <ul className={`shift-ss-menu${up ? " up" : ""}`} ref={menuRef}>
                    {options.map((o) => (
                        <li
                            key={o.value}
                            className={`shift-ss-opt${String(o.value) === String(value) ? " active" : ""}`}
                            onClick={() => { onChange(o.value); setOpen(false); }}
                        >
                            {o.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default ScrollSelect;
